module.exports = {
  buildVersion: "6.1.1",
  buildDate: 1759136047341,
}